<div class="banner" [ngClass]="{'banner-info': bannerType == 'info'}">
  <div class="banner-header" *ngIf="header">{{header}}</div>
  <div class="banner-subtext" *ngIf="subtext">{{subtext}}</div>
</div>
